import { FaCoffee } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const BROWN = "#4A2E23";
const AMBER = "#C68A4E";
const CREAM = "#FBF3E7";

const theme = {
  pageStyle: { backgroundColor: CREAM },
  headerClassName: "sticky top-0 z-20",
  headerStyle: { backgroundColor: BROWN },
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4 text-white",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-white/10",
  titleClassName: "font-black",
  badgeClassName: "absolute -left-1 -top-1 rounded-full bg-white px-1.5 text-[10px] font-bold",
  badgeStyle: { color: BROWN },
  cardClassName: "overflow-hidden rounded-2xl bg-white shadow-sm",
  PlaceholderIcon: FaCoffee,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl sm:aspect-[16/9]",
  placeholderStyle: { backgroundColor: "#EFE1D0", color: AMBER },
  itemTitleClassName: "text-2xl font-black",
  itemTitleStyle: { color: BROWN },
  descriptionClassName: "mt-3 leading-7 text-[#8A7362]",
  priceStyle: { color: AMBER },
  stepperClassName: "flex items-center rounded-full bg-white shadow",
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold text-white shadow-lg",
  ctaStyle: { backgroundColor: BROWN },
};

const BrewBitesFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default BrewBitesFoodDetailTheme;
